'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var defaultStyles = {
  fill: '#0077b5',
  margin: '0 8px',
  cursor: 'pointer',
  outline: 'none'
};

exports.default = function (_ref) {
  var style = _ref.style,
      className = _ref.className;
  var customStyles = Object.assign({}, defaultStyles, style);
  return _react2.default.createElement('svg', {
    style: customStyles,
    xmlns: 'http://www.w3.org/2000/svg',
    viewBox: '0 0 24 24',
    width: '24',
    height: '24'
  }, _react2.default.createElement('path', {
    d: 'M22.2,0H1.8C0.8,0,0,0.8,0,1.7v20.5c0,1,0.8,1.7,1.8,1.7h20.5c1,0,1.8-0.8,1.8-1.7V1.7C24,0.8,23.2,0,22.2,0z M7.1,20.5H3.6V9h3.6V20.5z M5.3,7.4c-1.1,0-2.1-0.9-2.1-2.1c0-1.1,0.9-2.1,2.1-2.1c1.1,0,2.1,0.9,2.1,2.1C7.4,6.5,6.5,7.4,5.3,7.4 z M20.5,20.5h-3.6v-5.6c0-1.3,0-3-1.9-3c-1.9,0-2.1,1.4-2.1,2.9v5.7H9.4V9h3.4v1.6h0c0.5-0.9,1.6-1.8,3.4-1.8 c3.6,0,4.3,2.4,4.3,5.5V20.5z'
  }));
};